import React from 'react'
import { IconFilter } from '../ui'
import { useAtomValue } from 'jotai'
import * as state from '../../states'

type IFiltersButtonIcon = {
	activeFiltersCount: number;
	filterFillFactor: number;
	onClick: () => void;
	styles?: React.CSSProperties;
}

export const FiltersButtonIcon = (props: IFiltersButtonIcon) => {
	const {
		activeFiltersCount = 0,
		filterFillFactor = 0,
		onClick,
		styles = {}
	} = props
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const stopColorEmpty = isThemeDark ? `var(--blackColor)` : `var(--whiteColor)`

	return (
		<i className={`filters-button icon`}
		   style={styles}
		   onClick={(event) => onClick()}
		>
			<IconFilter fillFactor={filterFillFactor} stopColorEmpty={stopColorEmpty}/>
			<span className="count">{activeFiltersCount}</span>
		</i>
	)
}